<template>
  <div class="form full-form auth-cover">
    <div class="form-container">
      <div class="form-form">
        <div class="form-form-wrap">
          <div class="form-container">
            <div class="form-content">
              <h1 class="mb-4">
                Log In to <router-link to="/"><span class="brand-name">E-Tourism Kabupaten Jepara</span></router-link>
              </h1>
              <form class="text-start" @submit.prevent="actionForm">
                <div class="form">
                  <div id="username-field" class="field-wrapper input">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-user">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <input type="text" class="form-control" :placeholder="$t('Enter') + ' ' + $t('Username')"
                      :class="[hasFormError.username ? (hasFormError.username ? 'is-invalid' : 'is-valid') : '']"
                      v-model="formData.username" @blur="loginStore.removeErrorFormSingle('username')" />
                    <div v-if="hasFormError.username" class="invalid-feedback">{{ hasFormError.username }}</div>
                  </div>

                  <div id="password-field" class="field-wrapper input mb-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="feather feather-lock">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <input :type="typePassword" class="form-control" :placeholder="$t('Enter') + ' ' + $t('Password')"
                      :class="[hasFormError.password ? (hasFormError.password ? 'is-invalid' : 'is-valid') : '']"
                      v-model="formData.password" @blur="loginStore.removeErrorFormSingle('password')" />
                    <div v-if="hasFormError.password" class="invalid-feedback">{{ hasFormError.password }}</div>
                  </div>
                  <template v-if="hasErrorSingle">
                    <div class="col-12">
                      <div class="alert alert-light-danger alert-dismissible border-0 mb-4" role="alert">
                        <strong>{{ $t('Failed') }}</strong> {{ hasErrorSingle }}
                        <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">×</button>
                      </div>
                    </div>
                  </template>
                  <div class="d-sm-flex justify-content-between">
                    <div class="field-wrapper toggle-pass d-flex align-items-center">
                      <p class="d-inline-block">{{ $t('Show Password') }}</p>
                      <label class="switch s-primary mx-2">
                        <input type="checkbox" class="custom-control-input" v-model="showPass" @change="showPassword" />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div class="field-wrapper">
                      <button type="submit" class="btn btn-primary" :disabled="isLoadingForm">
                        <span v-if="isLoadingForm" class="spinner-border text-white me-2 align-self-center loader-sm">
                          Loading...
                        </span>
                        Log In
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <p class="terms-conditions">
                Copyright © {{ year }}. E-Tourism Kabupaten Jepara. All rights reserved.
                Development by <a target="_blank" href="https://visualmedia.web.id">Visualmedia</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="form-image">
        <div class="l-image"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/store/auth/LoginStore';
import { useRouter } from 'vue-router';

const year = ref(new Date().getFullYear());

const loginStore = useLoginStore();
const { formData, hasFormError, isLoadingForm, hasErrorSingle } = storeToRefs(loginStore);
const router = useRouter();
loginStore.resetForm();

// show password
const typePassword = ref('password');
const showPass = ref(false);
const showPassword = () => {
  if (showPass.value) {
    typePassword.value = 'text';
  } else {
    typePassword.value = 'password';
  }
};
const actionForm = async () => {
  await loginStore.login();
  if (loginStore.isAuthenticated) {
    top.location = '/app/dashboard';
  }
};

// try login
const tryLogin = async () => {
  await loginStore.checkAuth();
  if (loginStore.isAuthenticated) {
    top.location = '/app/dashboard';
  }
};
tryLogin();

</script>

<style lang="scss" scoped>
// .form.full-form.auth-cover {
//   background-color: white;
// }
</style>
